export class DateUtil {
   public static convertTimeToDate(time: string | null) {
      const date: Date = new Date();
      const pieces = time?.split(':')
      let hour = 0, minute = 0, second = 0;

      if (pieces?.length === 3) {
         hour = parseInt(pieces[0], 10);
         minute = parseInt(pieces[1], 10);
         second = parseInt(pieces[2], 10);
      }

      if (pieces?.length === 2) {
         hour = parseInt(pieces[0], 10);
         minute = parseInt(pieces[1], 10);
         second = 0;
      }

      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute, second);
   }

   public static fixTimeString(time: string | null) {
      const pieces = time?.split(':')
      if (pieces?.length === 3) {
         return time;
      }

      if (pieces?.length === 2) {
         return time + ':00';
      }

      return null;
   }

   public static fixUtcDate() {
      const today = new Date();
      today.setMinutes(today.getMinutes() + today.getTimezoneOffset() * -1)
      return today;
   }

   public static calculateAge(birthday: Date) {
      const ageDifMs = Date.now() - birthday.getTime();
      const ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
   }
}
